import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import TombolaBaseComponent from '@/components/base/base.component';
import { GameState, IGameRepresentationChangedArgs, IGameStateChangedArgs, IGameRepresentation, IGameCallboardItem, IGame } from '@/components/game/_domain/models';
import { IGameController } from '@/components/game/_domain/models/game-controller';
import { getPathToCallImagesFolder } from '@/components/game/_domain';

@Component({
  name: 'RollerCoasterLastSixCallsComponent'
})
export default class RollerCoasterLastSixCallsComponent extends TombolaBaseComponent {
  @Prop() public gameController: IGameController;
  private gameState: GameState;
  private isVisible: boolean = true;
  private callsAsImages: boolean = false;
  private pathToCallImagesFolder: string = '';
  private lastSixCalls: IGameCallboardItem[] = [];

  private mounted() {
    const game = this.gameController.getGame();
    this.setSkin(game);

    Vue.nextTick(() => {
      this.gameController
          .onGameRepresentationChanged(this.handleGameRepresentationChanged)
          .onGameStateChanged(this.handleGameStateChanged);
    });
  }

  private setSkin(game: IGame): void {
    const gameIdentity = game.gameIdentity;
    const gameConfig = game.gameConfiguration;
    this.callsAsImages = gameConfig.showCallsAsImages;
    this.pathToCallImagesFolder = getPathToCallImagesFolder(gameIdentity.name, gameIdentity.clubName, gameConfig.callSkins);
  }

  private handleGameRepresentationChanged(eventArgs: IGameRepresentationChangedArgs) {
    const gameRepresentation: IGameRepresentation = eventArgs.currentGameRepresentation;
    const callboardItems = gameRepresentation.callboard.items;
    const currentCallNumber = gameRepresentation.callboard.currentCallNumber;

    this.lastSixCalls = this.getLastSixCallObjects(callboardItems, currentCallNumber);
  }

  private getLastSixCallObjects(callboardItems: IGameCallboardItem[], currentCallNumber: number): IGameCallboardItem[] {
    return callboardItems.filter((item) => item.callOrder > (currentCallNumber - 6) && item.isCalled)
                         .sort((itemA, itemB) => itemB.callOrder - itemA.callOrder);
  }

  private getPathToCallImage(currentCallValue: number): string {
    return `${this.pathToCallImagesFolder}${currentCallValue}.png`;
  }

  private handleGameStateChanged(eventArgs: IGameStateChangedArgs) {
    this.gameState = eventArgs.currentGameState;
    this.updateLastSixCallsVisibility();
  }

  private updateLastSixCallsVisibility() {
    if (this.gameState === GameState.WinnersDisplayed) {
      this.isVisible = false;
      this.lastSixCalls = [];
    }
    else if (this.gameState === GameState.Purchasing) {
      this.isVisible = true;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/game/implementations/uk/roller-coaster/_components/last-six-calls/last-six-calls.component.ts